import { getData } from 'api/requests/GET_CHAPTER_INFO';

import { getQueryKey } from 'helpers/getQueryKey';

const key = (id: string) => {
  return getQueryKey('CHAPTER_INFO', id.toString());
};

type Params = { id: string };

export const getChapterInfoOptions = (params: Params) => {
  return {
    queryKey: key(params.id),
    queryFn: async () => {
      const response = await getData(params.id);

      return response.filter((chapter) => {
        return chapter.hiddenInSource === false;
      });
    },
  };
};
